export default __webpack_public_path__ + "static/media/udea-main-logo-en.61d062e5.svg";